/** Referrals' pill as OnlyFans' URL names it: /my/statistics/statements/referrals/<earnings|creators|users>. */
export const REFERRAL_TABS = ['earnings', 'creators', 'users'] as const
export type ReferralTab = (typeof REFERRAL_TABS)[number]

/** The pill from the page's query (`tab=creators`); Earnings otherwise, as OnlyFans' More link opens it. */
export function referralsTab(query: string): ReferralTab {
  const tab = new URLSearchParams(query).get('tab')
  return (REFERRAL_TABS as readonly string[]).includes(tab ?? '') ? (tab as ReferralTab) : 'earnings'
}

/** The page's query for a pill (none for Earnings, the default). */
export function referralsQuery(tab: string): string {
  return tab === 'earnings' || !(REFERRAL_TABS as readonly string[]).includes(tab) ? '' : `tab=${tab}`
}
